import type {
  RyftPayoutMethodCreateRequestType,
  RyftPayoutMethodCreateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useRyftManagementPayoutMethodCreate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: RyftPayoutMethodCreateRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: "ryft-management/accounts/payout-methods",
        data,
      }).then(
        (response) =>
          apiV2AssertResponse(response)
            .data as RyftPayoutMethodCreateResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.RyftManagementAccount,
        ],
      });
    },
  });
};
